
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 0A16.006 16.006 0 001.217 9.878a16.005 16.005 0 0011.662 21.816 15.996 15.996 0 0019.123-15.692A15.999 15.999 0 0016.003.003zm0 1.333c2.901 0 5.736.862 8.148 2.474a14.663 14.663 0 016.234 15.055 14.668 14.668 0 01-19.997 10.69 14.67 14.67 0 015.614-28.219zm-.843 9.985l.117 9.523h1.523l.128-9.523zm.929 11.455c-.328 0-.577.095-.747.284-.164.182-.247.409-.247.682s.083.503.247.685c.17.176.419.263.747.263s.577-.087.747-.263c.17-.182.252-.412.252-.685s-.082-.5-.252-.682c-.17-.188-.419-.284-.747-.284z"}})])
          )
        }
      }
    